export class S1SystemVersion {
    versions: Map<string, string>;
    constructor(data: JSON) {
        this.versions = new Map();
        Object.entries(data).forEach(([key, value]) => {
            this.versions.set(key, value);
        });
    }
}